import { useMemo } from 'react';

import { useCheckPermissions } from './useCheckPermissions';

export type RouteType = {
  path: string;
  permissions: string[];
};

export function useDefaultRedirect(routeList: RouteType[], fallbackPath: string) {
  const checkPermissions = useCheckPermissions();

  return useMemo(() => {
    for (const route of routeList) {
      if (checkPermissions(route.permissions)) {
        return route.path;
      }
    }

    return fallbackPath;
  }, []);
}
